import Context from './Core/Context.js';
import SignalMap from './SignalMap.js';

class ApplicationContext extends Context {

	constructor() {
		super({signals: new SignalMap()});
	}

	/**
	 *
	 */
	startup() {

		// Enable logging on the event dispatcher
		//this.dispatcher.log = true;
		this._configureComponents();
		this._mapViews();
	}

	/**
	 * @private
	 */
	_configureComponents() {

		// Set the default ease
		//TweenMax.defaultEase = Quart.easeOut;
		//ParsleyValidator.setLocale(themeConfig.locale);
	}

	/**
	 * Setup view mappings
	 *
	 * @private
	 */
	_mapViews() {

		/**
		 * Map the selectors to the Views. The views will be automatically
		 * created when the selector exists on the page.
		 */
		this.views.map('.navigation', require('./Views/Templates/Navigation/Navigation.js'));
		this.views.map('.navigation', require('./Views/Templates/Navigation/StickyMenu.js'));
		this.views.map('.main-wrapper', require('./Views/Templates/MainWrapper/MainWrapper.js'));
		// this.views.map('.header__background', require('./Views/Templates/HeaderCarousel/HeaderCarousel.js'));
		this.views.map('.header__video', require('./Views/Templates/HeaderVideo/HeaderVideo.js'));
		this.views.map('.header__slideshow', require('./Views/Templates/HeaderSlideshow/HeaderSlideshow.js'));
		// this.views.map('.main-navigation__sub-list', require('./Views/Templates/MainNavigation/SubMenu.js'));
		// this.views.map('.menu-item-has-children.visual-dropdown', require('./Views/Templates/VisualSubmenu/VisualSubmenu.js'))

		// Modules
		this.views.map('.faq-accordion', require('./Views/Modules/FaqAccordion/FaqAccordion.js'));
		this.views.map('.boat-explorer', require('./Views/Modules/BoatExplorer/BoatExplorer.js'));
		this.views.map('.boat-highlights', require('./Views/Modules/BoatHighlights/BoatHighlights.js'));
		this.views.map('.sailing-rules', require('./Views/Modules/SailingRules/SailingRules.js'));
		this.views.map('.photo-slider', require('./Views/Modules/PhotoSlider/PhotoSlider.js'));
		this.views.map('.videoplayer', require('./Views/Modules/VideoPlayer/VideoPlayer.js'));
		this.views.map('.location-map', require('./Views/Modules/LocationMap/LocationMap.js'))
		this.views.map('.all-locations', require('./Views/Modules/AllLocationsMap/AllLocationsMap.js'))
	}
}

export default ApplicationContext;


// WEBPACK FOOTER //
// ./js/ApplicationContext.js